/*************************************************/
/* 3rd Party                                     */
/*************************************************/

// Passive event listeners
document.addEventListener('touchstart', () => { }, { passive: true });
document.addEventListener('touchmove', () => { }, { passive: true });

import { intersectionObservation } from "./partials/intersectionObservation.js";

/*************************************************/
/* Partials                                      */
/*************************************************/

import { header } from "./partials/header.js";
import { language } from "./partials/language.js";
import { banner } from "./partials/banner.js";
import { video } from "./partials/video.js";
import { collapsedText } from "./partials/collapsedText.js";
import { imageStack } from "./partials/imageStack.js";
import { modal } from "./partials/modal.js";
import { cookies } from "./partials/cookies.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    const body = document.querySelector('body'),
    bodyLoadingClass = 'is-loading';

       //Handle scroll to submitted form element
    //    const formSubmittedElement = document.getElementById("umbraco-forms-form-submitted--clienti");
    //    if(formSubmittedElement){
    //        window.scrollTo(0,formSubmittedElement.closest('.form-item').offsetTop);
    //    }

    intersectionObservation();
    header(body);
    banner();
    language();
    modal(body, bodyLoadingClass);
    video();
    imageStack();
    collapsedText();
    cookies();
});
